import React from 'react';
import { TariffFormData, TariffFormState } from '../steps/tariff-sub-steps/TariffSubStep1';
import { IDeviceItem } from 'Services/widgets/interfaces';


export type TariffFormActions =
| { type: 'LOAD_STARTED' }
| { type: 'LOAD_SUCCESS'; payload: { data: TariffFormData } }
| { type: 'UPDATE_DEVICES'; payload: { data: IDeviceItem[] } }
| { type: 'SHOW_LOADING' }
| { type: 'HIDE_LOADING' }
| { type: 'LOAD_ERROR' };

export type TariffFormReducer = React.Reducer<TariffFormState, TariffFormActions>;

export const tariffFormReducer: TariffFormReducer = ( prevState, action ) => {
  switch ( action.type ) {
    case 'LOAD_STARTED': {
      const nextState: TariffFormState = {
        ...prevState,
        isLoading: true,
        deviceItems: [],
      };
      return nextState;
    }
    case 'LOAD_SUCCESS': {
      const payload = action.payload.data;
      return {
        ...prevState,
        isLoading: false,
        tariffFormData: payload.tariffFormData,
        deviceItems: payload.deviceItems,
      };
    }
    case 'UPDATE_DEVICES': {
      const payload = action.payload;
      return {
        ...prevState,
        isLoading: false,
        deviceItems: payload.data,
      };
    }
    case 'SHOW_LOADING': {
      return {
        ...prevState,
        isLoading: true,
      };
    }
    case 'HIDE_LOADING': {
      return {
        ...prevState,
        isLoading: false,
      };
    }
    case 'LOAD_ERROR': {
      return {
        ...prevState,
        isLoading: false,
      };
    }
    default:
      return prevState;
  }
};
